import {
  type ActivityFeed,
  type AttachmentView,
  type CommentView,
  type MentionCandidate,
} from '@apm/contracts';
import { apiFetch } from '../../lib/http';

export const collaborationApi = {
  comments: (taskId: string) => apiFetch<CommentView[]>(`/tasks/${taskId}/comments`),

  addComment: (taskId: string, body: string) =>
    apiFetch<CommentView>(`/tasks/${taskId}/comments`, {
      method: 'POST',
      body: { body },
    }),

  updateComment: (commentId: string, body: string) =>
    apiFetch<void>(`/comments/${commentId}`, { method: 'PATCH', body: { body } }),

  deleteComment: (commentId: string) =>
    apiFetch<void>(`/comments/${commentId}`, { method: 'DELETE' }),

  activity: (taskId: string, limit = 50) =>
    apiFetch<ActivityFeed>(`/tasks/${taskId}/activity?limit=${limit}`),

  attachments: (taskId: string) => apiFetch<AttachmentView[]>(`/tasks/${taskId}/attachments`),

  attach: (taskId: string, fileId: string) =>
    apiFetch<void>(`/tasks/${taskId}/attachments/${fileId}`, { method: 'POST' }),

  detach: (taskId: string, fileId: string) =>
    apiFetch<void>(`/tasks/${taskId}/attachments/${fileId}`, { method: 'DELETE' }),

  mentionCandidates: (projectId: string) =>
    apiFetch<MentionCandidate[]>(`/projects/${projectId}/mention-candidates`),
};

/**
 * Khoá query bắt đầu bằng `comment` / `task` để khớp với cách
 * `useNotificationStream` invalidate: nó tách tiền tố của tên event
 * (`comment.mentioned` ⇒ `['comment']`) rồi invalidate theo đó.
 *
 * Đặt tên lệch đi thì thông báo SSE vẫn tới nhưng danh sách không tự làm mới,
 * và triệu chứng là "phải F5 mới thấy" — đúng thứ tiêu chí "Xong khi" cấm.
 */
export const collaborationKeys = {
  comments: (taskId: string) => ['comment', 'list', taskId] as const,
  activity: (taskId: string) => ['task', 'activity', taskId] as const,
  attachments: (taskId: string) => ['task', 'attachments', taskId] as const,
  mentionCandidates: (projectId: string) => ['project', 'mentions', projectId] as const,
};
